import { createQuiz } from "@/components/quizEngine";

const traits = ["free", "righteous", "kind", "loyal", "proud", "clever", "mysterious", "fierce", "gentle"];

const bank = [
  ["Your favorite way to spend a night hunt:", [
    ["Play a flute and see what shows up", { free: 2, mysterious: 1 }],
    ["Follow the rules and stay in formation", { righteous: 2 }],
    ["Protect the juniors", { kind: 2, loyal: 1 }],
    ["Charge in first", { fierce: 2, proud: 1 }],
  ]],
  ["Pick a drink:", [
    ["Emperor's Smile wine, lots of it", { free: 3 }],
    ["Plain water. Alcohol is forbidden", { righteous: 2, gentle: 1 }],
    ["Lotus root soup made by family", { kind: 2, loyal: 1 }],
    ["Tea, while gossiping", { clever: 1, mysterious: 1 }],
  ]],
  ["Someone breaks a sect rule. You…", [
    ["Laugh, I break them all the time", { free: 3 }],
    ["Make them copy the rules a hundred times", { righteous: 2, proud: 1 }],
    ["Quietly cover for them", { kind: 2, loyal: 1 }],
    ["Yell at them, then help anyway", { fierce: 2, loyal: 1 }],
  ]],
  ["Your weapon of choice:", [
    ["A dizi flute", { free: 1, mysterious: 2 }],
    ["A guqin", { gentle: 2, righteous: 1 }],
    ["A sword with a family name", { proud: 2, loyal: 1 }],
    ["A whip of lightning", { fierce: 3 }],
  ]],
  ["Where would you live?", [
    ["A lotus pier by the lake", { free: 1, loyal: 2 }],
    ["The Cloud Recesses, quiet and misty", { gentle: 2, righteous: 1 }],
    ["A golden tower", { proud: 2, clever: 1 }],
    ["Wherever the road takes me", { free: 2, kind: 1 }],
  ]],
  ["Your friend is in trouble with the whole world. You…", [
    ["Stand by them, even if everyone hates me", { loyal: 3, righteous: 1 }],
    ["Ask them to explain first", { clever: 1, gentle: 1 }],
    ["Get angry at them, but secretly worry", { fierce: 2, loyal: 1 }],
    ["Find a clever way to help in secret", { clever: 2, mysterious: 1 }],
  ]],
  ["Pick an animal:", [
    ["Bunnies, so many bunnies", { gentle: 2, kind: 1 }],
    ["Donkey with an attitude", { free: 2 }],
    ["A loyal spirit dog", { loyal: 2, fierce: 1 }],
    ["Butterflies in moonlight", { mysterious: 2 }],
  ]],
  ["People describe you as:", [
    ["Chaotic and fun", { free: 3 }],
    ["Serious and noble", { righteous: 3 }],
    ["Grumpy but caring", { fierce: 2, loyal: 1 }],
    ["Sweet and harmless (or am I?)", { mysterious: 2, clever: 1 }],
  ]],
  ["Your biggest strength:", [
    ["Creativity", { free: 1, clever: 2 }],
    ["Discipline", { righteous: 2, proud: 1 }],
    ["A big heart", { kind: 3 }],
    ["Never backing down", { fierce: 2 }],
  ]],
  ["The juniors are scared of a ghost. You…", [
    ["Tease the ghost and teach them a trick", { free: 2, kind: 1 }],
    ["Play a calming song", { gentle: 3 }],
    ["Stand in front of them", { loyal: 2, fierce: 1 }],
    ["Find out what the ghost wants", { clever: 1, kind: 1, mysterious: 1 }],
  ]],
  ["Pick a color:", [
    ["Black and red", { free: 1, mysterious: 1, fierce: 1 }],
    ["White and light blue", { righteous: 1, gentle: 2 }],
    ["Purple", { proud: 1, loyal: 1, fierce: 1 }],
    ["Gold", { proud: 2, clever: 1 }],
  ]],
  ["You've been gone for 13 years. You come back and…", [
    ["Cause trouble right away", { free: 3 }],
    ["Find the one who waited for me", { loyal: 2, gentle: 1 }],
    ["Look for the truth", { clever: 2, righteous: 1 }],
    ["Hide who I am", { mysterious: 3 }],
  ]],
  ["How do you show love?", [
    ["Teasing nonstop", { free: 2 }],
    ["Quietly being there, always", { gentle: 2, loyal: 1 }],
    ["Cooking for you", { kind: 3 }],
    ["Yelling \"I don't care!\" while caring a lot", { fierce: 2, proud: 1 }],
  ]],
  ["Your hidden talent:", [
    ["Inventing new spells", { clever: 2, free: 1 }],
    ["Playing music that calms spirits", { gentle: 2 }],
    ["Knowing everyone's secrets", { mysterious: 2, clever: 1 }],
    ["Archery", { proud: 1, fierce: 1 }],
  ]],
  ["Someone insults your family. You…", [
    ["Insult them back, funnier", { free: 2, fierce: 1 }],
    ["Calmly correct them", { righteous: 2 }],
    ["Draw my sword", { fierce: 2, proud: 1 }],
    ["Smile and remember it forever", { mysterious: 2 }],
  ]],
  ["Pick a place for a picnic:", [
    ["A lotus lake, stealing seed pods", { free: 2, kind: 1 }],
    ["A quiet mountain spring", { gentle: 2 }],
    ["A fancy garden", { proud: 2 }],
    ["Somewhere secret only I know", { mysterious: 2 }],
  ]],
  ["What do you value most?", [
    ["Freedom", { free: 3 }],
    ["Doing what's right", { righteous: 3 }],
    ["Family", { loyal: 3 }],
    ["Power and respect", { proud: 2, clever: 1 }],
  ]],
  ["You find a mysterious ghost arm. You…", [
    ["Investigate, how exciting", { free: 1, clever: 2 }],
    ["Seal it carefully", { righteous: 2, gentle: 1 }],
    ["Ask a friend for help", { loyal: 1, kind: 1 }],
    ["Keep it a secret for now", { mysterious: 2 }],
  ]],
  ["Your teaching style:", [
    ["Make it a game", { free: 2, kind: 1 }],
    ["Strict, with 3,000 rules", { righteous: 3 }],
    ["Patient and kind", { gentle: 2, kind: 1 }],
    ["Tough love", { fierce: 2 }],
  ]],
  ["How do you handle sadness?", [
    ["Laugh it off", { free: 2 }],
    ["Play music alone", { gentle: 2, mysterious: 1 }],
    ["Get angry instead", { fierce: 2 }],
    ["Lean on family", { loyal: 2, kind: 1 }],
  ]],
  ["Your dream future:", [
    ["Travel the world with my soulmate", { free: 2, loyal: 1 }],
    ["Protect the innocent", { righteous: 2, kind: 1 }],
    ["Lead my sect proudly", { proud: 2, loyal: 1 }],
    ["Live quietly, peacefully", { gentle: 3 }],
  ]],
];

const characters = [
  { name: "Wei Wuxian", title: "The Yiling Patriarch", text: "Free-spirited, clever and endlessly playful, with a heart that always chooses to protect others.", traits: { free: 3, clever: 2, kind: 1 }, colors: ["#1b1b1f", "#c1121f", "#f2f0ea"], image: "/img/md/wei-wuxian.jpg" },
  { name: "Lan Wangji", title: "Hanguang-Jun", text: "Quiet, righteous and steady as a mountain. You wait for the ones you love, no matter how long.", traits: { righteous: 2, gentle: 2, loyal: 2 }, colors: ["#fff8e7", "#a0d2ff", "#f2f0ea"], image: "/img/md/lan-wangji.jpg" },
  { name: "Jiang Cheng", title: "Sect Leader of Yunmeng Jiang", text: "Hot-tempered and proud, but you carry your family on your shoulders without complaint.", traits: { fierce: 3, proud: 1, loyal: 2 }, colors: ["#6a2c70", "#9b5de5", "#1b1b1f"] },
  { name: "Jiang Yanli", title: "The gentle shijie", text: "Warm, kind and quietly strong. Your soup and your love hold everyone together.", traits: { kind: 3, gentle: 2, loyal: 1 }, colors: ["#e6ccff", "#ffd6e0", "#fff8e7"], image: "/img/md/jiang-yanli.jpg" },
  { name: "Wen Ning", title: "The Ghost General", text: "Gentle and shy, but endlessly loyal and stronger than anyone expects.", traits: { loyal: 3, gentle: 2, kind: 1 }, colors: ["#6b5b5b", "#1b1b1f", "#2b2d6e"] },
  { name: "Wen Qing", title: "The brilliant healer", text: "Sharp, practical and fiercely protective of your family.", traits: { clever: 2, loyal: 2, fierce: 1 }, colors: ["#c1121f", "#ff6f61", "#1b1b1f"] },
  { name: "Lan Xichen", title: "Zewu-Jun", text: "Gracious, gentle and kind to everyone. You always see the best in people.", traits: { gentle: 3, kind: 2, righteous: 1 }, colors: ["#fff8e7", "#3a86ff", "#a0d2ff"] },
  { name: "Jin Ling", title: "The young lord of Lanling Jin", text: "Proud and loud, but brave, and you grow into someone truly good.", traits: { proud: 2, fierce: 2, loyal: 1 }, colors: ["#e9b949", "#ffd166", "#fff8e7"], image: "/img/md/jin-ling.jpg" },
  { name: "Lan Sizhui", title: "The kind Lan disciple", text: "Polite, gentle and wise beyond your years. Everyone feels safe around you.", traits: { kind: 2, gentle: 2, righteous: 1 }, colors: ["#f2f0ea", "#a0d2ff", "#8fe3cf"] },
  { name: "Lan Jingyi", title: "The loud Lan disciple", text: "Honest, noisy and funny. You say exactly what you think.", traits: { free: 2, fierce: 1, loyal: 1 }, colors: ["#f2f0ea", "#9fa8ff", "#ffd166"] },
  { name: "Nie Huaisang", title: "The fan-loving sect leader", text: "\"I don't know\" is your favorite phrase. But you know much more than anyone thinks.", traits: { mysterious: 3, clever: 2 }, colors: ["#2d6a4f", "#2a9d8f", "#fff8e7"], image: "/img/md/nie-huaisang.jpg" },
  { name: "Jin Guangyao", title: "The smiling chief cultivator", text: "Charming, clever and always smiling. Your ambition runs deep.", traits: { clever: 3, mysterious: 2, proud: 1 }, colors: ["#e9b949", "#c1121f", "#fff8e7"] },
  { name: "Xiao Xingchen", title: "The wandering cultivator", text: "Pure-hearted and kind, always helping strangers on the road.", traits: { righteous: 2, kind: 2, gentle: 1 }, colors: ["#fff8e7", "#f2f0ea", "#a0d2ff"] },
  { name: "Xue Yang", title: "The candy-loving trickster", text: "Chaotic, unpredictable and dangerous, with a sweet tooth and a dark grin.", traits: { fierce: 2, mysterious: 2, free: 1 }, colors: ["#1b1b1f", "#7b2cbf", "#ffd166"] },
];

export const MD = createQuiz({ traits, bank, characters });

export const MD_PAIRS = [
  ["Wei Wuxian", "Lan Wangji"], ["Wei Wuxian", "Jiang Cheng"], ["Jiang Cheng", "Jiang Yanli"],
  ["Wen Ning", "Wen Qing"], ["Lan Sizhui", "Lan Jingyi"], ["Wei Wuxian", "Wen Ning"],
];
